import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { SiteHeader } from '@/components/site-header';
import { HeroSlider } from '@/components/hero-slider';
import { SolutionBrowser } from '@/components/solution-browser';
import { EnquiryForm } from '@/components/enquiry-form';
import { SiteBehavior } from '@/components/site-behavior';

const islands = { SiteHeader, HeroSlider, SolutionBrowser, EnquiryForm };
const mounted = new WeakSet<Element>();
function start() {
  document.querySelectorAll<HTMLElement>('[data-beda-island]').forEach(element => {
    if (mounted.has(element)) return;
    const Component = islands[element.dataset.bedaIsland as keyof typeof islands];
    if (!Component) return;
    mounted.add(element);
    const props = JSON.parse(element.dataset.bedaProps || '{}');
    hydrateRoot(element, <Component {...props} />, { identifierPrefix: element.dataset.bedaPrefix || 'beda-' });
  });
  const behavior = document.createElement('div');
  behavior.hidden = true;
  document.body.appendChild(behavior);
  createRoot(behavior).render(<SiteBehavior />);

  // Keep the source's native scrolling cards editable as ordinary WordPress page HTML.
  document.querySelectorAll<HTMLElement>('.mobile-carousel').forEach(carousel => {
    const viewport = carousel.querySelector<HTMLElement>('.mobile-carousel-viewport');
    const buttons = carousel.querySelectorAll<HTMLButtonElement>('.mobile-carousel-controls button');
    if (!viewport || buttons.length !== 2) return;
    const update = () => {
      const back = viewport.scrollLeft > 2;
      const forward = viewport.scrollLeft + viewport.clientWidth < viewport.scrollWidth - 2;
      buttons[0].disabled = !back; buttons[1].disabled = !forward;
      viewport.tabIndex = back || forward ? 0 : -1;
    };
    const move = (direction: number) => viewport.scrollBy({
      left: direction * viewport.clientWidth,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
    buttons[0].addEventListener('click', () => move(-1));
    buttons[1].addEventListener('click', () => move(1));
    viewport.addEventListener('keydown', event => {
      if (event.target !== event.currentTarget) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    });
    viewport.addEventListener('scroll', update, { passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(viewport);
    update();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
else start();
